module.exports = __webpack_public_path__ + "static/media/baker.a554ef21.jpg";